import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Button, Box, Grid, MenuItem, Alert, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Select } from '@mui/material';
import { z } from "zod";
import { FormModal, RHFTextField, RHFSelect } from "../components/form";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // For auto-generating tables in PDF
import api, { fetchTechnicalNewInstallations, updateTechnicalNewInstallation, emailTechnicalNewInstallationPdf, fetchCustomers, fetchVehicles, fetchSolutions, fetchUsers, fetchSalesNewInstallation, fetchCustomerSupportNewInstallation } from "../services/ApiService";
import dayjs from 'dayjs'; // Install with npm: npm install dayjs
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';

const installationSchema = z.object({
  installation_date: z.string().min(1, "Required"),
  resource_name: z.string().min(1, "Required"),
  imei: z.string().min(1, "Required"),
  remarks: z.string().optional(),
});

export function TechnicalNewInstallation() {
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
  const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [selectedSale, setSelectedSale] = React.useState(null);
  const [saleModalOpen, setSaleModalOpen] = React.useState(false);
  const [selectedCustomerSupport, setSelectedCustomerSupport] = React.useState(null);
  const [csModalOpen, setCSModalOpen] = React.useState(false);
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };
  const handleViewSaleDetail = async (saleId) => {
    try {
      const response = await fetchSalesNewInstallation(saleId);
      console.log(response.data);

      setSelectedSale(response.data);
      setSaleModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch sale detail:", error);
    }
  };
  const handleViewCustomerSupportDetail = async (saleId) => {
    try {
      const response = await fetchCustomerSupportNewInstallation(saleId);
      console.log(response.data);

      setSelectedCustomerSupport(response.data);
      setCSModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch sale detail:", error);
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [editModalOn, setEditModalOn] = React.useState(false);
  const handleEditOff = () => setEditModalOn(false)
  const handleEditOn = (row) => {
    setEditModalOn(true)
    setSelectedRow(row)
  }
  React.useEffect(() => {
    fetchHauliers();
    fetchTruck();
    fetchDeliveries();
    fetchDevices();
    loadUsers()
  }, []);
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [devicesOptions, setDevicesOptions] = React.useState([]);
  const [usersOptions, setUsersOptions] = React.useState([]);

  const [users, setUsers] = React.useState([]);

  const loadUsers = async () => {
    try {
      const response = await fetchUsers();
      console.log(response);

      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      console.log(response.data);
      console.log(deviceDict);

      setUsersOptions(deviceDict)
      setUsers(response.data);
      console.log(users);

    } catch (error) {
      console.error("Failed to fetch users", error);
    }
  };
  const fetchDeliveries = async () => {
    try {
      const response = await fetchTechnicalNewInstallations();
      console.log(response.data);
      setEmployees(response.data);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const handleSendEmail = async (saleId) => {
    setSendingEmailId(saleId);

    try {
      await emailTechnicalNewInstallationPdf(saleId, {});
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Email error:", error);
      alert("Failed to send email.");
    } finally {
      setSendingEmailId(null);
    }
  };

  const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
      await updateTechnicalNewInstallation(saleId, updatedSale);

      // Update state in frontend
      setEmployees((prevData) =>
        prevData.map((item) =>
          item.id === saleId ? { ...item, status: newStatus } : item
        )
      );

      showSnackbar('Status updated successfully', 'success');
    } catch (error) {
      console.error('Failed to update status:', error);
      showSnackbar('Failed to update status', 'error');
    }
  };
  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const allNames = response.data.map((employee) => employee.client_name);
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      setHauliers(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const allNames = response.data.map((employee) => employee.name);
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      setDevice(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      const allNames = response.data.map((employee) => employee.name);
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      setTrucks(allNames);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const [device, setDevice] = React.useState([])

  const [haulier, setHauliers] = React.useState([])
  const [trucks, setTrucks] = React.useState([])

  const [employees, setEmployees] = React.useState([])
  const [modalOpen, setModalOpen] = React.useState(false);
  // Save employees to localStorage on update
  React.useEffect(() => {
    // localStorage.setItem('employees', JSON.stringify(employees));
  }, [employees]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a2'); // Landscape A2

  // Title
  doc.setFontSize(18);
  doc.text('Technical New Installations Report', 14, 16);

  // Columns matching UI table
  const columns = [
    'Technical Log #',
    'Sale #',
    'Customer Support #',
    'Remarks',
    'IMEI',
    'Resource Name',
    'Installation Date',
    'Document',
  ];

  // Rows aligned with UI table
  const tableData = employees.map((row) => [
    row.id,
    row.sale,
    row.customer_support,
    row.remarks || '',
    row.imei_details?.imei || '-',
    usersOptions[row.resource_name] || '',
    formatDatetimeLocal(row.installation_date),
    row.document_url ? 'Available' : 'Not Available',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2.5,
    },
    columnStyles: {
      0: { cellWidth: 25 },  // Technical Log #
      1: { cellWidth: 25 },  // Sale #
      2: { cellWidth: 35 },  // Customer Support #
      3: { cellWidth: 40 },  // Remarks
      4: { cellWidth: 25 },  // IMEI
      5: { cellWidth: 35 },  // Resource Name
      6: { cellWidth: 40 },  // Installation Date
      7: { cellWidth: 30 },  // Document
    },
    theme: 'grid',
  });

  doc.save('Technical_New_Installation_Report.pdf');
};

  const TechnicalLogModal = ({ open, handleClose }) => {
    const [imageFile, setImageFile] = React.useState(null);

    const resourceOptions = users
      .filter(u => u.department === "Monit")
      .reduce((acc, u) => ({ ...acc, [u.id]: u.name || u.username }), {});

    return (
      <FormModal
        open={open}
        onClose={handleClose}
        title="Attach Device"
        schema={installationSchema}
        defaultValues={{ installation_date: "", resource_name: "", imei: "", remarks: "" }}
        onSubmit={async (data) => {
          const formatted = dayjs(data.installation_date).format("YYYY-MM-DDTHH:mm:ss");
          const fd = new FormData();
          fd.append("installation_date", formatted);
          Object.entries(data).forEach(([k, v]) => {
            if (k !== "installation_date" && v !== null && v !== undefined && v !== "") fd.append(k, v);
          });
          if (imageFile) fd.append("image", imageFile);
          try {
            await api.post("/technical-new-installation/", fd);
            showSnackbar("Installation log created successfully", "success");
            fetchDeliveries();
          } catch (err) {
            showSnackbar("Failed to create installation log", "error");
            throw err;
          }
        }}
        submitLabel="Add"
        width={400}
      >
        {({ control }) => (
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <RHFTextField
                control={control}
                name="installation_date"
                label="Installation Date"
                type="datetime-local"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <RHFSelect
                control={control}
                name="resource_name"
                label="Resource Name"
                options={resourceOptions}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField
                control={control}
                name="imei"
                label="IMEI"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField
                control={control}
                name="remarks"
                label="Remarks"
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>Image (optional)</Typography>
                <input type="file" accept="image/*" style={{ width: "100%" }} onChange={(e) => setImageFile(e.target.files?.[0] ?? null)} />
              </Box>
            </Grid>
          </Grid>
        )}
      </FormModal>
    );
  };


  function getBase64Image(imgPath) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgPath; // Ensure this path points to your public folder image

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL(); // This will give you the base64 string
        resolve(dataUrl); // Return the complete base64 string (including header)
      };

      img.onerror = reject;
    });
  }

  const handleExportInvoice = (record) => {
    const doc = new jsPDF();

    // Create a blue strip at the top with the word 'Invoice'
    doc.setFillColor(0, 123, 255); // Set blue color for the strip (RGB)
    doc.rect(0, 0, 210, 20, 'F'); // Create a filled rectangle (top strip)

    // Add 'Invoice' text on the blue strip at the top, aligned left
    doc.setFontSize(24); // Increase font size
    doc.setFont('helvetica', 'bold'); // Set font to bold
    doc.setTextColor(255, 255, 255); // White text color
    doc.text('Invoice', 14, 14); // Left-aligned text (positioned at 14, 14)

    // Add Logo Image to PDF (start after the top strip)
    getBase64Image('/logo2.png').then((base64) => {
      // Add the image at the top (position at x=14, y=25, just after the blue strip)
      doc.addImage(base64, 'PNG', 14, 25, 50, 20); // Adjust width and height as needed
      let yPosition = 55; // Starting Y position for data below the logo

      // Add Invoice Date and To row
      doc.setFontSize(12); // Adjust size for the row text
      doc.setFont('helvetica', 'normal'); // Set font to normal
      doc.setTextColor(0, 0, 0); // Black text color

      // Invoice Date and To (with space in between)
      doc.text('Invoice Date:', 14, yPosition); // Label for Invoice Date
      doc.text(record.date, 40, yPosition); // Value of Invoice Date

      // Add space and then 'To' label
      doc.text('To:', 140, yPosition); // Label for To
      doc.text(record.haulier, 150, yPosition); // Value for To (Haulier)

      // Increase Y position for the next field after this row
      yPosition += 10;

      // Key-Value style (starting from the next line after the table)
      const fieldNames = [
        'Time', 'Truck', 'Expiry Date', 'Remarks'
      ];

      const fieldValues = [
        record.time, record.vehicle, record.expiryDate, record.remarks
      ];

      // Loop through the fields and print them as key-value pairs
      for (let i = 0; i < fieldNames.length; i++) {
        doc.setFontSize(12); // Adjusted size for field values
        doc.text(`${fieldNames[i]}:`, 14, yPosition); // Field name (Key)
        doc.text(fieldValues[i], 70, yPosition); // Field value
        yPosition += 10; // Increase Y position for the next field
      }

      // Table for Device ID and Cost
      doc.setFontSize(12);
      const tableStartY = yPosition; // Save the starting Y position for the table
      const cellHeight = 10; // Height for each table row

      // Table headers
      doc.setFont('helvetica', 'bold');
      doc.text('Device ID', 14, tableStartY);
      // Draw horizontal line under headers
      doc.line(14, tableStartY + 1, 190, tableStartY + 1); // Horizontal line below the headers

      // Table content
      doc.setFont('helvetica', 'normal');
      doc.text(record.device, 14, tableStartY + cellHeight);

      // Draw horizontal line under the table content
      doc.line(14, tableStartY + cellHeight + 1, 190, tableStartY + cellHeight + 1); // Line under the values

      // Table content
      doc.setFont('helvetica', 'normal');
      doc.text("Subtotal", 14, tableStartY + 2 * cellHeight);

      // Draw horizontal line under the table content
      doc.line(14, tableStartY + 2 * cellHeight + 1, 190, tableStartY + 2 * cellHeight + 1); // Line under the values


      // Increase Y position for the next section after the table
      yPosition = tableStartY + 2 * cellHeight; // Update yPosition after table

      // Create a blue strip at the bottom with the word 'Invoice'
      doc.setFillColor(0, 123, 255); // Set blue color for the strip (RGB)
      doc.rect(0, 285, 210, 20, 'F'); // Create a filled rectangle (top strip)
      // Add 'Invoice' text on the blue strip at the bottom, aligned left
      doc.setFontSize(12); // Increase font size
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setTextColor(255, 255, 255); // White text color
      doc.text('This is a computer-generated invoice. It does not require any signature.', 33, 293); // Left-aligned text (positioned at 14, 293)

      // Update the record's generated status
      // Assuming you have a state or method to update the record, for example:
      record.generated = true; // Update generated flag here

      // Optionally update the state in your parent component if needed
      // setRecord(updatedRecords); // Assuming setRecord is the state setter function

      // Save the document
      doc.save('Device_Report.pdf');
    }).catch((err) => {
      console.error('Error loading image:', err);
    });
  };


  const EditOperationModal = ({
    open,
    handleClose,
    formData,
  }) => {
    const [imageFile, setImageFile] = React.useState(null);

    const resourceOptions = users
      .filter(u => u.department === "Monit")
      .reduce((acc, u) => ({ ...acc, [u.id]: u.name || u.username }), {});

    return (
      <FormModal
        open={open}
        onClose={handleClose}
        title="Edit Installation Log"
        schema={installationSchema}
        defaultValues={{
          installation_date: formData?.installation_date ? formatDatetimeLocal(formData.installation_date) : "",
          resource_name: String(formData?.resource_name ?? ""),
          imei: formData?.imei ?? "",
          remarks: formData?.remarks ?? "",
        }}
        onSubmit={async (data) => {
          const formatted = dayjs(data.installation_date).format("YYYY-MM-DDTHH:mm:ss");
          const fd = new FormData();
          fd.append("installation_date", formatted);
          Object.entries(data).forEach(([k, v]) => {
            if (k !== "installation_date" && v !== null && v !== undefined && v !== "") fd.append(k, v);
          });
          if (imageFile) fd.append("image", imageFile);
          try {
            await updateTechnicalNewInstallation(formData.id, fd);
            showSnackbar("Installation log updated successfully", "success");
            fetchDeliveries();
          } catch (err) {
            showSnackbar("Failed to update installation log", "error");
            throw err;
          }
        }}
        submitLabel="Update"
        width={400}
      >
        {({ control }) => (
          <>
            <Box sx={{ mx: -3, mt: -3, mb: 2, px: 3, py: 1, bgcolor: "action.hover", borderBottom: "1px solid", borderColor: "divider", display: "flex", gap: 3, flexWrap: "wrap" }}>
              <Typography variant="caption">
                Created At: {formData?.created_at?.slice(0, 19).replace("T", " ")}
              </Typography>
            </Box>
            <Grid container spacing={2.5}>
              <Grid item xs={12}>
                <RHFTextField
                  control={control}
                  name="installation_date"
                  label="Installation Date"
                  type="datetime-local"
                  required
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <RHFSelect
                  control={control}
                  name="resource_name"
                  label="Resource Name"
                  options={resourceOptions}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <RHFTextField
                  control={control}
                  name="imei"
                  label="IMEI"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <RHFTextField
                  control={control}
                  name="remarks"
                  label="Remarks"
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>Image (optional)</Typography>
                  <input type="file" accept="image/*" style={{ width: "100%" }} onChange={(e) => setImageFile(e.target.files?.[0] ?? null)} />
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </FormModal>
    );
  };


  function formatDatetimeLocal(iso) {
    if (!iso) return "";
    const dt = new Date(iso);
    return new Date(dt.getTime() - dt.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
  }
  const COLUMNS = [
    { key: 'id', label: 'Technical Log #' },
    { key: 'sale', label: 'Sale #', render: (row) => <span onClick={() => handleViewSaleDetail(row.sale)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{row.sale}</span> },
    { key: 'customer_support', label: 'Customer Support #', render: (row) => <span onClick={() => handleViewCustomerSupportDetail(row.customer_support)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{row.customer_support}</span> },
    { key: 'remarks', label: 'Remarks' },
    { key: 'imei', label: 'IMEI', render: (row) => row.imei_details?.imei || '-' },
    { key: 'resource_name', label: 'Resource Name', render: (row) => usersOptions[row.resource_name] },
    { key: 'installation_date', label: 'Installation Date', render: (row) => formatDatetimeLocal(row.installation_date) },
    { key: 'document_url', label: 'Document', render: (row) => row.document_url ? <a href={`https://crm-backend.monit.tech/${row.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a> : <span style={{ color: '#999' }}>Not Available</span> },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
      <TechnicalLogModal open={modalOpen} handleClose={handleClose} />
      {editModalOn && selectedRow && (
        <EditOperationModal formData={selectedRow} open={editModalOn} handleClose={handleEditOff} />
      )}
      <DataTable
        title="Technical New Installation"
        columns={COLUMNS}
        rows={employees}
        toolbarActions={<Button variant="contained" color="primary" onClick={handleExport}>Export to PDF</Button>}
        renderActions={(row) => (
          <Box display="flex" gap="4px" alignItems="center">
            <IconButton color="secondary" size="small" onClick={() => handleEditOn(row)} sx={{ p: '6px' }}><EditIcon /></IconButton>
            <IconButton color="primary" size="small" onClick={() => handleSendEmail(row.id)} sx={{ p: '6px' }} disabled={sendingEmailId === row.id}>
              {sendingEmailId === row.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
            </IconButton>
            <Select value={row.status} onChange={(e) => handleStatusChange(row.id, e.target.value, row)} size="small" sx={{ ml: 1, minWidth: 100 }}>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Received">Received</MenuItem>
              <MenuItem value="Complete">Complete</MenuItem>
            </Select>
          </Box>
        )}
      />
      <Dialog open={saleModalOpen} onClose={() => setSaleModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Sale Details</DialogTitle>
        <DialogContent>
          {selectedSale ? (
            <Box>
              <Typography variant="body1"><strong>Customer:</strong> {haulierOptions[selectedSale.customer]}</Typography>
              <Typography variant="body1"><strong>Solution:</strong> {devicesOptions[selectedSale.solution]}</Typography>
              <Typography variant="body1"><strong>Corporate:</strong> {selectedSale.corporate}</Typography>
              <Typography variant="body1"><strong>POC Name:</strong> {selectedSale.poc_name}</Typography>
              <Typography variant="body1"><strong>POC Contact:</strong> {selectedSale.poc_contact}</Typography>
              <Typography variant="body1"><strong>Plan:</strong> {selectedSale.plan}</Typography>
              <Typography variant="body1"><strong>Unit:</strong> {selectedSale.unit}</Typography>
            </Box>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaleModalOpen(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={csModalOpen} onClose={() => setCSModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Customer Support Details</DialogTitle>
        <DialogContent>
          {selectedCustomerSupport ? (
            <Box>
              <Typography variant="body1"><strong>Vehicle:</strong> {selectedCustomerSupport.vehicle_details.name}</Typography>
              <Typography variant="body1"><strong>Location:</strong> {selectedCustomerSupport.location}</Typography>
            </Box>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCSModalOpen(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}
